import request from '@/utils/request'

export function getAtvOrgInfo(params) {
    return request({
        url: '/v2/sec/orgConfig/getAtvOrgInfo',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function getOrgInfo(params) {
    return request({
        url: '/v2/sec/orgConfig/getOrgInfo',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function createOrgPartInfo (params) {
    return request({
        url: '/v2/sec/orgConfig/createOrgPartInfo',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function removeOrgPartInfo (params) {
    return request({
        url: '/v2/sec/orgConfig/removeOrgPartInfo',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function getSelectOrgPartInfo (params) {
    return request({
        url: '/v2/sec/orgConfig/getSelectOrgPartInfo',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function updateOrgPartInfo (params) {
    return request({
        url: '/v2/sec/orgConfig/updateOrgPartInfo',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function getOrgList(params) {
    return request({
        url: '/v2/sec/orgConfig/orgGetListHeader',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function updateMainOrg(params) {
    return request({
        url: '/v2/sec/orgConfig/updateMainOrg',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function removeMainOrg(params) {
    return request({
        url: '/v2/sec/orgConfig/removeMainOrg',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function checkPromotionCode(params) {
    return request({
        url: '/v2/sec/orgConfig/checkPromotionCode',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function updateOrgAdminUser(params) {
    return request({
        url: '/v2/sec/orgConfig/updateOrgAdminUser',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function createTempOrg(params) {
    return request({
        url: '/v2/sec/orgConfig/createTempOrg',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function joinRequestOrginfo(params) {
    return request({
        url: '/v2/sec/orgConfig/joinRequestOrginfo',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function leaveOrgUser(params) {
    return request({
        url: '/v2/sec/orgConfig/leaveOrgUser',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function isLastUser(params) {
    return request({
        url: '/v2/sec/orgConfig/isLastUser',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function removeRequestTempOrginfo(params) {
    return request({
        url: '/v2/sec/orgConfig/removeRequestTempOrginfo',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function getTempOrgInfo() {
    return request({
        url: '/v2/sec/orgConfig/getTempOrgInfo',
        method: 'post'
    })
}

export function auth(params) {
    return request({
        url: '/v2/sec/orgConfig/company/auth',
        method: 'post',
        data: params
    })
}

export function authOrg(params) {
    return request({
        url: '/v2/sec/orgConfig/company/authOrg',
        method: 'post',
        data: params
    })
}

export function updateOrgInfo(params) {
    return request({
        url: '/v2/sec/orgConfig/updateOrgInfo',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function getOrgListAdm(params) {
    return request({
        url: '/v2/sec/orgConfig/getOrgListAdm',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function createOrgGroupUser(params) {
    return request({
        url: '/v2/sec/orgConfig/createOrgGroupUser',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}

export function removeOrgReqUser (params) {
    return request({
      url: '/v2/sec/orgConfig/removeOrgReqUser',
      method: 'post',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      data: params
    })
 }

 export function confirmOrgReqUser (params) {
    return request({
      url: '/v2/sec/orgConfig/confirmOrgReqUser',
      method: 'post',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      data: params
    })
}

export function uploadUserImg (params) {
    return request({
      url: '/v2/sec/orgConfig/upload',
      method: 'post',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      data: params
    })
 }

 export function deleteUserImg (params) {
     return request({
       url: '/v2/sec/orgConfig/deleteUserImg',
       method: 'post',
       headers: {
         'Content-Type': 'application/json;charset=utf-8'
       },
       data: params
     })
  }
 
 export function getUserImgList (params) {
    return request({
      url: '/v2/sec/orgConfig/getUserImgList',
      method: 'post',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      data: params
    })
 }

 export function editOrgEmailinfo (params) {
    return request({
      url: '/v2/sec/orgConfig/editOrgEmailinfo',
      method: 'post',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      data: params
    })
}
export function searchOrgAdmin (params) {
    return request({
      url: '/v2/sec/orgConfig/searchOrgAdmin',
      method: 'post',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      data: params
    })
}


export function transferAdminUser (params) {
    return request({
      url: '/v2/sec/orgConfig/transferAdminUser',
      method: 'post',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      data: params
    })
  }

  export function deleteOrgTemp(params) {
    return request({
        url: '/v2/sec/orgConfig/deleteOrgTemp',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
}